// Ensure jQuery is loaded and DOM is ready
jQuery(document).ready(function($) {
 

    const $sauceCategorySelect = $('#sauce-category-select');
    const $sauceTabsMenu = $('#sauce-tabs-menu'); 

    if ($sauceCategorySelect.length && $sauceTabsMenu.length) {

        // When the mobile dropdown value changes
        $sauceCategorySelect.on('change', function() {
            const selectedTabId = $(this).val(); 


            const $targetTabLink = $sauceTabsMenu.find('a[href="#' + selectedTabId + '"]');

            if ($targetTabLink.length) {

                $targetTabLink.trigger('click');
            }
        });
        $sauceTabsMenu.on('on.zf.tabsChange', function() {
            const $activeTabLink = $(this).find('.tabs-title.is-active a');

            if ($activeTabLink.length) {
                const activeTabId = $activeTabLink.attr('href').substring(1); // Remove the '#'

                $sauceCategorySelect.val(activeTabId);
            }
        });

    }
});